import { render, staticRenderFns } from "./FitnessRoutines.vue?vue&type=template&id=f14bbbd8&"
import script from "./FitnessRoutines.vue?vue&type=script&lang=js&"
export * from "./FitnessRoutines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports